import { ChangeDetectionStrategy, Component, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateActionComponent } from 'app/dialogs/create-action/create-action.component';
import { CreatePersonComponent } from 'app/dialogs/create-person/create-person.component';
import { FileUploadOptions } from 'app/services/common/fileupload/fileupload.component';
import { ControllerType } from 'app/services/http-client.service';
import { CategoryService } from 'app/services/models/category.service';
import { CompanyService } from 'app/services/models/company.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { LabelService } from 'app/services/models/label.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-company-detail',
  templateUrl: './company-detail.component.html',
  styleUrls: ['./company-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CompanyDetailComponent implements OnInit {
  id: number = null;
  data: any = {};
  @Output() options: Partial<FileUploadOptions> = {
    accept: ".png, .jpg, .jpeg",
    action: "CreateCompanyUpload",
    controller: ControllerType.Company,
    explanation: 'Firma logosunu seçin veya buraya sürükleyin...',
    isAdminPage: true,
  }
  constructor(
    private router: Router,
    private _route: ActivatedRoute,
    private companyService: CompanyService,
    private categoryService: CategoryService,
    private toastrService: ToastrService,
    private labelService: LabelService,
    private modalService: NgbModal,
    private currencyService:CurrencyService 
  ) { }

  public searchValue = '';
  public selectBasicLoading = false;
  selectBasic: any;
  selectedCompany: any;
  itemCategory: any;
  files: any[] = [];
  offer: any[] = [];
  order: any[] = [];
  currencies:any[] = [];
  public contentHeader: object;

  @BlockUI('section-block') blockUI: NgBlockUI;
  isReadonly: boolean = true;
  selectControllerTypeId: number;
  public selectedImageId?: number;

  async ngOnInit() {
    this.companyService.event$.subscribe(result => {
      this._route.params.subscribe(async (params) => {
        this.id = params['id'];
        await this.getById(this.id);
        this.options.queryString = `CompanyId=${this.id}`
      });
    })
    this._route.params.subscribe(async (params) => {
      this.id = params['id'];
      await this.getById(this.id);
      this.options.queryString = `CompanyId=${this.id}`
    });

    this.contentHeader = {
      headerTitle: 'Firma Detay',
      actionButton: true,
      breadcrumb: {
        type: '',
        links: [
          {
            name: 'Firma Listesi',
            isLink: true,
            link: '/admin/company'
          },
          {
            name: 'Detay',
            isLink: false
          }
        ]
      }
    };

    await this.getAllCategory();
    await this.getAllCurrencies();
  }
  expandedIndex: number | null = null;

  toggleExpand(index: number): void {
    console.log(index);
    if (this.expandedIndex === index) {
      this.expandedIndex = null;  // Aynı satıra tıklayınca kapatmak için
    } else {
      this.expandedIndex = index;  // Yeni satırı genişletmek için
    }
  }

  showCrateAksiyon(item){
    const modal = this.modalService.open(CreateActionComponent,{
      size : 'lg',
    });
    modal.componentInstance.data = {
      requestTask:item,
      actionId : null
    }
  }

  formatPhoneNumber(phoneNumber: string): string {
    return phoneNumber?.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  }

  onSelectCustomerType(event: any) {
    this.selectControllerTypeId = event.target.value;
  }

  async getById(id: number) {
    this.blockUI.start("Firma bilgileri yükleniyor..");
    const company = await this.companyService.getByIdCompany(id);
    this.data = company;
    console.log(this.data);
    this.blockUI.stop();

    
    await this.getByIdFile(this.id);
  }

  confirmedRemove(){
    this.router.navigate(['/admin/company'])
  }

  

  async getByIdFile(id) {
    const data = await this.companyService.getCompanyFileId(id);
    this.files = data;
    console.log(this.files);
    const showcasedImage = this.files.find(image => image.showcase);
    this.selectedImageId = showcasedImage?.id;
  }

  public onRadioChange(selectedId: number) {
    console.log('Selected Image ID:', selectedId);
    this.companyService.changeCompanyFileShowcase(this.id, selectedId).then(() => {
      this.companyService.sendEvent(true);
      this.toastrService.success("Gösterilecek dosya seçildi.");
    }).catch(() => {
      this.toastrService.error("Gösterilecek dosya seçilemedi.");
    })
  }

  async removeCompanyFile(fileId, companyId) {
    this.companyService.RemoveCompanyFile(companyId, fileId).then(() => {
      this.companyService.sendEvent(true);
      this.toastrService.success("Başarılı bir şekilde dosya silindi.");
    }).catch((err) => {
      this.toastrService.error("Dosya silinirken bir problem oluştu.")
    });
  }

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.searchValue = val;

    setTimeout(async () => {
      try {
        const data = await this.companyService.getAllCompany(this.searchValue, 0, 100);
        this.selectBasic = data.company;
      } catch (error) {
        console.error('Error loading companies', error);
      }
    }, 500);
  }

  async getAllCurrencies(){
    const data = await this.currencyService.getAllPageCurrency(0,100,'');
    console.log(data);
    this.currencies = data.currenies
  }

  async getAllCategory() {
    const data = await this.categoryService.getAllCategory(0, 100, null, 2);
    console.log(data);
    this.itemCategory = data.categories;
  }

  onSelect(event) {
    const selectedCompany = event;
    console.log(event);
    this.router.navigate(['/admin/company', selectedCompany.id]);
  }

  toggleReadonly() {
    this.isReadonly = !this.isReadonly;
  }

  async saveData() {
    const labelNames = this.data.label.map(label => label.labelName);
    if (!this.isReadonly) {
      const response = await this.companyService.updateCompany({
        id: this.data.id,
        companyName: this.data.companyName,
        mail: this.data.email,
        phoneNumber: this.data.phoneNumber,
        phoneNumber2: this.data.phoneNumber2,
        address: this.data.address,
        taxAdministration: this.data.taxAdministration,
        taxNumber: this.data.taxNumber,
        futuresDay: this.data.futuresDay,
        discountRate: this.data.discountRate,
        description: this.data.description,
        categoryId: this.data.categoryId,
        labels: labelNames,
        currencyId:this.data.currencyId
      });
      if (response.status === true) {
        this.toastrService.success(response.message);
        this.isReadonly = true;
        await this.getById(this.data.id);
      } else {
        this.toastrService.error(response.message);
      }
    }
  }

  limit(element, max) {
    var max_chars = max;
    if (element.value.length > max_chars) {
      element.value = element.value.substr(0, max_chars);
    }
  }

  newLabel: string = '';
  addLabel(event: KeyboardEvent) {
    event.preventDefault(); // Prevent form submission on Enter key

    if (this.newLabel.trim()) {
      // Add the new label if it doesn't already exist
      if (!this.data.label.some(label => label.labelName === this.newLabel.trim())) {
        this.data.label.push({ labelName: this.newLabel.trim() });
      }
      // Clear the input field
      this.newLabel = '';
    }
  }

  removeLabel(labelId: number) {
    this.data.label = this.data.label.filter(label => label.labelId !== labelId);

    // Optionally call the backend API to remove the label
    this.removeLabelFromBackend(labelId);
  }

  saveLabelToBackend(labelId: number, labelName: string) {
    // Implement your backend call to save the label
    console.log(`Saving label to backend: ID=${labelId}, Name=${labelName}`);
  }

  async removeLabelFromBackend(labelId: number) {
    // Implement your backend call to remove the label
    console.log(`Removing label from backend: ID=${labelId}`);
    const data = await this.labelService.removeLabelCompany(this.data.id, labelId);
    console.log(data);
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return 'Oluşturuldu';
      case 2:
        return 'İptal Edildi';
      case 3:
        return 'Onaylandı';
      case 4:
        return 'Reddedildi';
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-glow badge-info';    // Info class for status 1
      case 2:
        return 'badge badge-glow badge-danger';  // Danger class for status 2
      case 3:
        return 'badge badge-glow badge-success'; // Success class for status 3
      case 4:
        return 'badge badge-glow badge-warning'; // Warning class for status 4
      default:
        return 'badge badge-glow badge-secondary'; // Secondary class for unknown status
    }
  }

}
